import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { LoginButton } from "../buttons/login-button";
import { LogoutButton } from "../buttons/logout-button";
import { SignupButton } from "../buttons/signup-button";
import { useThemeMode } from "../../providers/ThemeModeProvider";

export const NavBarButtons = () => {
  const { isAuthenticated } = useAuth0();
  const { mode, toggleMode, allowsDarkMode } = useThemeMode();

  return (
    <div className="nav-bar__buttons">
      {allowsDarkMode ? (
        <button
          type="button"
          className="nav-bar__theme-toggle"
          onClick={toggleMode}
          aria-label={`Switch to ${mode === 'dark' ? 'light' : 'dark'} theme`}
          aria-pressed={mode === 'dark'}
          data-testid="nav-theme-toggle"
        >
          {mode === 'dark' ? '☀ Light' : '◐ Dark'}
        </button>
      ) : null}
      {!isAuthenticated && (
        <>
          <SignupButton />
          <LoginButton />
        </>
      )}
      {isAuthenticated && (
        <>
          <LogoutButton />
        </>
      )}
    </div>
  );
};
